/**
 *
 * Asynchronously loads the component for International Sider
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from '../Loading'

export const FPLSider = loadable({
  loader: () => import('./index'),
  loading: <Loading />
})
